(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('spRequestVerificationToken', spRequestVerificationToken);

    spRequestVerificationToken.$inject = ['$http'];

    /* @ngInject */
    function spRequestVerificationToken($http) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        }
        return directive;

        function linkFunc(scope, el, attrs, ctrl) {
          //  $http.defaults.headers.common['RequestVerificationToken'] = attrs.spRequestVerificationToken || "no request verification token";
        }
    }
})();

